export default __webpack_public_path__ + "static/media/pmt.f463922c.png";